import React from 'react'

const TableHead = (props) => {
    return (
        <thead className="ShippingCarrierRuleTableHead TableHead">
        <tr className="RuleHeadTable">
            <th className="brand-name">Brand name</th>
            <th className="store">Store</th>
            <th className="created-at">Created at</th>
            <th className="updated-at">Updated at</th>
            <th className="Action">Action</th>
        </tr>
        </thead>
    )
}

export default TableHead
